import { api } from '@ai/common/src/api/axios';
import { TariffPlanPurchase } from '@type/tariffPlanPurchase';

class TariffPlanPurchaseService {
  private baseUrl = '/platform/api/v1/tariff_plan_purchase';

  getList = async (userId?: string) =>
    api.get<TariffPlanPurchase[]>(`${this.baseUrl}${userId ? `?user_id=${userId}` : ''}`);

  create = async ({ tariffPlanId, userId }: { tariffPlanId: string; userId: string }) =>
    api.post<TariffPlanPurchase>(this.baseUrl, {
      tariff_plan_id: tariffPlanId,
      user_id: userId,
    });

  delete = async (purchaseId: string) =>
    api.delete<{ id: string; message: string }>(`${this.baseUrl}/${purchaseId}`);
}

export const tariffPlanPurchaseService = new TariffPlanPurchaseService();
